const StepsAnnual = ({
	numberOfSteps,
	currentStep,
	setCurrentStep,
	isDisabled,
}: {
	currentStep: number;
	setCurrentStep: (step: number) => void;
	numberOfSteps: number;
	isDisabled: boolean;
}) => {
	return (
		<div className='flex items-center mx-auto'>
			{[...Array(numberOfSteps)].map((_, index) => {
				const isLastItem = index === numberOfSteps - 1;
				const stylesText = (() => {
					const styles = {
						completed: `bg-h-primary`,
						pending: `bg-h-neutral-90`,
					};

					if (index >= currentStep) {
						return styles.pending;
					}

					return styles.completed;
				})();

				const stylesLine = (() => {
					const styles = {
						completed: `bg-h-primary`,
						pending: `bg-h-neutral-90`,
					};

					if (index + 1 >= currentStep) {
						return styles.pending;
					}

					return styles.completed;
				})();

				return (
					<>
						<button
							disabled={isDisabled}
							onClick={() => setCurrentStep(index + 1)}
							key={index}
							className={` size-5 rounded-full flex items-center justify-center text-white text-sm ${stylesText}`}
						>
							{index + 1}
						</button>
						{!isLastItem && <div className={`h-[2px] w-10 ${stylesLine}`} />}
					</>
				);
			})}
		</div>
	);
};

export default StepsAnnual;
